import { render, staticRenderFns } from "./ScreenTimeEmptyScreen.vue?vue&type=template&id=0bc415dd&scoped=true&"
import script from "./ScreenTimeEmptyScreen.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeEmptyScreen.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeEmptyScreen.vue?vue&type=style&index=0&id=0bc415dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc415dd",
  null
  
)

export default component.exports